import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField  from "../../../../../../../../ui/TextField";
import StateInfoField from "./StateInfoField";
import { SmallStateIcon, StateTextColor } from "../../../../../components/StateStyles";
import CardPersonBlock from "../../../../../../../../ui/CardPersonBlock";

const useStyles = makeStyles({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 32
    }
  },
  mainGrid:{
    marginTop: 8
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
    block: {
      margin: "35px 0 15px 0"
    },
    blockrow: {
      marginTop: 16
    },
    blockfieldValue: {
      marginTop: 8
    },
    label: {
      fontSize: 12
    },
    svgIcon:{
      display: "inline-block",
      marginBottom: "-8px",
      marginRight: "8px"
    },
    typofield: {
      width: 140,
      minWidth: 140,
      paddingRight: 16
    },
    typovalue: {
      fontSize: 12,
    }
  });



const SkillEditPassport = ({change, skill, skillAuthors, skillId}) => {
        const { root, heading, mainGrid,
                block, blockrow, blockfieldValue,
                svgIcon, typofield, typovalue
                } = useStyles();

  return (
    (skill && skill.info && skill.data) ? (
    <div className={root}>
      <Typography className={heading}>Общие сведения</Typography>
      <Grid container spacing={2} className={mainGrid}>
        <Grid item xs={12} md={6}>
            <TextField
              value={skill.info.worldSkill ? (skill.info.worldSkill.cis + ' | ' + skill.info.worldSkill.typeName + ' | ' + skill.info.worldSkill.name) : 'не указано'}
              label="На основе компетенции WorldSkills"
              readOnly
            />
            <TextField
              value={skill.info.category ? skill.info.category.name : 'не указано'}
              label="Блок"
              readOnly
            />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            value={skill.data.name}
            label="Наименование"
            readOnly
          />
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <TextField
                  value={skill.data.code}
                  label="Код"
                  readOnly
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                  readOnly
                  value={skill.info.type ? skill.info.type.name : ''}
                  label="Тип"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                  readOnly
                  value={skill.info.createDate}
                  label="Год"
              />
            </Grid>
        </Grid>
      </Grid>
    </Grid>

{skill.info.sourceTypeId === 1 &&
    <div className={block}>
      <div className={blockrow}>
        <Typography
          className={typofield}
          variant="caption"
          color="textSecondary">
          Статус компетенции:
        </Typography>
        <Typography className={typovalue} variant="caption">
        {skill.info.statusId ? <>
          {SmallStateIcon(skill.info.statusId, svgIcon)}
          <span style={{color: StateTextColor(skill.info.statusId)}}>{skill.info.statusName}</span>
          </> : '-'}
        </Typography>
      </div>

      <div className={blockrow}>
        <StateInfoField field="Дата создания:" value={skill.info.createDate || '-'} />
      </div>
      {(skill.info.expertise && skill.info.expertise.id && skill.info.expertise.id>-1) &&
      <div className={blockrow}>
        <StateInfoField field="Дата экспертизы:" value={skill.info.expertise.statusDate || '-'} />
      </div>}
      {(skill.info.publication && skill.info.publication.id && skill.info.publication.id>-1) &&
      <div className={blockrow}>
        <StateInfoField field="Дата публикации:" value={skill.info.publication.statusDate || '-'} />
      </div>}

    </div>}

{(skillAuthors && skillAuthors.length>0) ? (
    <div className={block}>
      <Typography className={heading}>Авторы/Составители компетенции</Typography>
      <div style={{ "display": "block"}}>
        {skillAuthors.editors.map(({ personId, personName, orgName, personAvatar }) =>
        <CardPersonBlock personId={personId} name={personName} desc={orgName} image={personAvatar}/>
        )}
      </div>
    </div>
  ):(<></>)}

  {(skill.info.expertise && skill.info.expertise.expert && skill.info.expertise.expert.id) &&
  <div className={block}>
    <Typography className={heading}>Эксперт</Typography>
    <div style={{ "display": "block"}}>
      <CardPersonBlock personId={skill.info.expertise.expert.personId}
          name={skill.info.expertise.expert.personName}
          desc={skill.info.expertise.expert.orgName}
          image={skill.info.expertise.expert.personAvatar}/>
    </div>
  </div>}

  </div>
  ):(<></>)
  );
};


export default SkillEditPassport;
